import React from "react"

export const languages = {
  en: {
    guide: "Download the guide",
    readMore: "Read more",
    prefooter: {
      body: "Diginnova è il network per la digital innovation che nasce dagli oltre 50 anni di esperienza di Telmotor. I suoi partner sono imprese innovative, che credono nel progresso tecnologico, affrontano le sfide del futuro e si aprono a nuove opportunità di partnership.",
      project: "A project of",
      partner: "Partner",
    },
    seeProjects: "See all",
    locale: "en",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    sendRequestForm: "Send",
    requestSent: "Request sent",
    loading: "Sending...",
    validationError:
      "Please answer all questions and accept the privacy policy before submitting the form.",
    formInputTexts: {
      privacyPolicy:
        "I consent to the use of my personal data to be updated on new arrivals, exclusive products and direct marketing purposes related to the services offered and receive proposals in line with my interests through the analysis of my previous purchases",
      name: "Name*",
      surname: "Surname*",
      fullName: "Full name*",
      company: "Company",
      address: "Street",
      city: "City",
      province: "Province",
      zipCode: "Zip Code",
      phone: "Phone",
      message: "Message",
    },
    questionnaire: {
      title: "Tell us what you think",
      subtitle:
        "Answer the questions and fill out the form to tell us what you think about Transition Plans 4.0 and 5.0!",
      questions: [
        {
          id: 1,
          type: "yes_no",
          question:
            "Before becoming interested in Transition Plans 4.0 or 5.0, did your company already have innovation investments planned?",
          options: ["YES", "NO"],
        },
        {
          id: 2,
          type: "yes_no",
          question:
            "If the Plans were not renewed, do you think your company would be held back in its innovation path?",
          options: ["YES", "NO"],
        },
        {
          id: 3,
          type: "multiple_choice",
          question:
            "Which areas of innovation do you consider most urgent for the future of your company?",
          options: [
            "Digitization and interconnection of machinery",
            "Process automation with robots and AI",
            "Human skills development",
            "Energy efficiency and sustainability",
            "Network and data security",
          ],
        },
      ],
    },
  },
  "en-US": {
    guide: "Download the guide",
    readMore: "Read more",
    seeProjects: "See all",
    prefooter: {
      body: "Diginnova è il network per la digital innovation che nasce dagli oltre 50 anni di esperienza di Telmotor. I suoi partner sono imprese innovative, che credono nel progresso tecnologico, affrontano le sfide del futuro e si aprono a nuove opportunità di partnership.",
      project: "A project of",
      partner: "Partner",
    },
    locale: "en-US",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Latest news",
    contact: "Contact us",
    sendRequestForm: "Send",
    requestSent: "Request sent",
    loading: "Sending...",
    copyright: "© 2024 Diginnova - P.IVA 04524160167 - All rights reserved",
    validationError:
      "Please answer all questions and accept the privacy policy before submitting the form.",
    formInputTexts: {
      privacyPolicy:
        "I consent to the use of my personal data to be updated on new arrivals, exclusive products and direct marketing purposes related to the services offered and receive proposals in line with my interests through the analysis of my previous purchases",
      name: "Name*",
      surname: "Surname*",
      fullName: "Full name*",
      company: "Company*",
      address: "Street",
      city: "City",
      province: "Province",
      zipCode: "Zip Code",
      phone: "Phone",
      message: "Message",
    },
    questionnaire: {
      title: "Tell us what you think",
      subtitle:
        "Answer the questions and fill out the form to tell us what you think about Transition Plans 4.0 and 5.0!",
      questions: [
        {
          id: 1,
          type: "yes_no",
          question:
            "Before becoming interested in Transition Plans 4.0 or 5.0, did your company already have innovation investments planned?",
          options: ["YES", "NO"],
        },
        {
          id: 2,
          type: "yes_no",
          question:
            "If the Plans were not renewed, do you think your company would be held back in its innovation path?",
          options: ["YES", "NO"],
        },
        {
          id: 3,
          type: "multiple_choice",
          question:
            "Which areas of innovation do you consider most urgent for the future of your company?",
          options: [
            "Digitization and interconnection of machinery",
            "Process automation with robots and AI",
            "Human skills development",
            "Energy efficiency and sustainability",
            "Network and data security",
          ],
        },
      ],
    },
  },
  it: {
    guide: "Scarica la guida",
    readMore: "Leggi di più",
    prefooter: {
      body: "Diginnova è il network per la digital innovation che nasce dagli oltre 50 anni di esperienza di Telmotor. I suoi partner sono imprese innovative, che credono nel progresso tecnologico, affrontano le sfide del futuro e si aprono a nuove opportunità di partnership.",
      project: "Un progetto di",
      partner: "Partner",
    },
    seeProjects: "Vedi tutti",
    contact: "contattaci",
    copyright:
      "© 2024 Diginnova  - P.IVA 04524160167 - Tutti i diritti riservati",
    locale: "it",
    discoverMore: "Scopri di più",
    all: "Tutti",
    search: "Cerca",
    results: "risultati",
    noResults: "Nessun risultato",
    download: "Scarica",
    latestArticles: "Ultime news",
    sendRequestForm: "Invia",
    requestSent: "Richiesta inviata",
    loading: "Invio in corso...",
    validationError:
      "Per favore rispondi a tutte le domande e accetta la privacy policy prima di inviare il form.",
    formInputTexts: {
      privacyPolicy:
        "Acconsento all’uso dei miei dati personali per essere aggiornato sui nuovi arrivi, prodotti in esclusiva e per le finalità di marketing diretto correlate ai servizi offerti e ricevere proposte in linea con i miei interessi attraverso l’analisi dei miei precedenti acquisti",
      name: "Nome*",
      surname: "Cognome*",
      fullName: "Nome completo*",
      company: "Azienda",
      address: "Via",
      city: "Città",
      province: "Provincia",
      zipCode: "CAP",
      phone: "Telefono",
      message: "Messaggio",
    },
    questionnaire: {
      title: "DICCI COSA NE PENSI",
      subtitle:
        "Rispondi alle domande e compila il form per dirci cosa ne pensi dei Piani Transizione 4.0 e 5.0!",
      questions: [
        {
          id: 1,
          type: "yes_no",
          question:
            "Prima di interessarsi ai Piani Transizione 4.0 o 5.0, la tua azienda aveva già in programma investimenti in innovazione?",
          options: ["SI", "NO"],
        },
        {
          id: 2,
          type: "yes_no",
          question:
            "Se i Piani non venissero rinnovati, pensi che la tua azienda sarebbe frenata nel suo percorso di innovazione?",
          options: ["SI", "NO"],
        },
        {
          id: 3,
          type: "multiple_choice",
          question:
            "Quali ambiti di innovazione ritieni più urgenti per il futuro della tua azienda?",
          options: [
            "Digitalizzazione e interconnessione dei macchinari",
            "Automazione dei processi con robot e AI",
            "Sviluppo delle competenze del personale",
            "Efficientamento energetico e sostenibilità",
            "Sicurezza delle reti e dei dati",
          ],
        },
      ],
    },
  },
}

export const i18nContext = React.createContext(languages.it)
